"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeTypes = void 0;
const react_1 = __importDefault(require("react"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const solid_1 = require("@heroicons/react/solid");
const elements_ui_icon_1 = __importStar(require("@hydrogen/elements.ui.icon"));
var BadgeTypes;
(function (BadgeTypes) {
    BadgeTypes["accent"] = "accent";
    BadgeTypes["danger"] = "danger";
    BadgeTypes["warn"] = "warn";
    BadgeTypes["success"] = "success";
    BadgeTypes["neutral"] = "neutral";
    BadgeTypes["filter"] = "filter";
    BadgeTypes["info"] = "info";
})(BadgeTypes = exports.BadgeTypes || (exports.BadgeTypes = {}));
function Badge(props) {
    var _a, _b;
    const baseClasses = (0, elements_ui_utils_1.classNames)('inline-flex gap-2 whitespace-nowrap items-center py-0.5 font-sans', elements_ui_utils_1.globalColorClasses.focus.replace('focus-visible:', 'focus-within:'));
    const baseBadgeClasses = 'font-semibold text-xs px-2 rounded-badge';
    const typeClasses = {
        [BadgeTypes.accent]: (0, elements_ui_utils_1.classNames)(baseBadgeClasses, 'bg-accent-200 text-accent-700'),
        [BadgeTypes.danger]: (0, elements_ui_utils_1.classNames)(baseBadgeClasses, 'bg-danger-200 text-danger-700'),
        [BadgeTypes.warn]: (0, elements_ui_utils_1.classNames)(baseBadgeClasses, 'bg-warn-200 text-warn-700'),
        [BadgeTypes.success]: (0, elements_ui_utils_1.classNames)(baseBadgeClasses, 'bg-success-200 text-success-700'),
        [BadgeTypes.neutral]: (0, elements_ui_utils_1.classNames)(baseBadgeClasses, 'bg-misc-200 text-primary-500'),
        [BadgeTypes.filter]: 'text-sm h-7 px-2 bg-accent-200 text-primary-500 border border-accent-300 rounded',
        [BadgeTypes.info]: (0, elements_ui_utils_1.classNames)(baseBadgeClasses, 'bg-info-200 text-info-700'),
    };
    const type = props.type || BadgeTypes.neutral;
    const customColor = props.color
        ? (0, elements_ui_utils_1.classNames)(props.color, baseBadgeClasses)
        : '';
    return (react_1.default.createElement("span", { className: (0, elements_ui_utils_1.classNames)(props.onClick && 'relative', (_a = props.className) !== null && _a !== void 0 ? _a : '', baseClasses, customColor || typeClasses[type]) }, (_b = props.title) !== null && _b !== void 0 ? _b : null,
        props.onClick && (react_1.default.createElement("button", { type: "button", className: "inline-flex items-center justify-center flex-shrink-0 rounded-full focus:outline-none", onClick: props.onClick },
            react_1.default.createElement("span", { className: "absolute inset-0" }),
            react_1.default.createElement("span", { className: "sr-only" }, "Remove option"),
            react_1.default.createElement(elements_ui_icon_1.default, { icon: solid_1.XIcon, className: "block", size: elements_ui_icon_1.IconsSizes.medium })))));
}
exports.default = Badge;
//# sourceMappingURL=badge.js.map